import React from 'react';
import PropTypes from 'prop-types';

import ProductAddOnListItem from '../ProductAddOnListItem/ProductAddOnListItem';
import { StyledHeader, StyledProductList, StyledProductListItem } from './ProductAddOnListStyles';
import useDyRecommendationWidgetData from '../../hooks/useDyRecommendationWidget';

var _ref = React.createElement('div', null);

var ProductAddOnList = function ProductAddOnList(props) {
  var sizeOption = props.selectedOptions && props.selectedOptions.size && props.selectedOptions.size;

  var dyData = useDyRecommendationWidgetData({
    dySlug: props.addOnListTag,
    sizeOption: sizeOption,
    maxItems: 5
  });

  if (dyData.items.length > 0) {
    var listSet = new Set();
    var listItems = sizeOption ? dyData.items.filter(function (item, ind, arr) {
      return item.item.size === sizeOption || sizeOption.split('/').some(function (size) {
        return size === item.item.size;
      }) || item.item.size.split('/').some(function (size) {
        return size === sizeOption;
      }) || !item.item.size;
    }) : dyData.items;

    var listItemsRender = listItems.filter(function (item, ind, arr) {
      return listItems.findIndex(function (prod) {
        return prod.item.name === item.item.name;
      }) >= ind;
    }).map(function (item, ind) {
      return React.createElement(
        StyledProductListItem,
        { key: item.item.sku },
        React.createElement(ProductAddOnListItem, {
          key: 'product-add-on-list-item-' + ind,
          item: item,
          handleSetAddOnListSelectedItems: props.handleSetAddOnListSelectedItems,
          setActiveProductForAddOnModal: props.setActiveProductForAddOnModal
        })
      );
    });

    return React.createElement(
      'div',
      { className: 'product-addon-list' },
      React.createElement('div', {
        'data-dy-widget-id': dyData.widgetId,
        'data-dy-strategy-id': dyData.strategy,
        'data-dy-feed-id': dyData.feedId
      }),
      React.createElement(
        StyledHeader,
        null,
        dyData.title
      ),
      React.createElement(
        StyledProductList,
        null,
        listItemsRender
      )
    );
  } else {
    return _ref;
  }
};

ProductAddOnList.propTypes = {
  addOnListTag: PropTypes.string,
  selectedOptions: PropTypes.object,
  handleSetAddOnListSelectedItems: PropTypes.func.isRequired,
  setActiveProductForAddOnModal: PropTypes.func.isRequired
};

export default ProductAddOnList;